const defaultLabel = 'Pendente';


function getColorForStatusDuimp(status) {
  const processing = [
    "TRANSMITINDO_CAPA",
    "TRANSMITINDO_ITENS",
    "INICIANDO_TRANSMISSAO_ITENS"
  ];

  const done = [
    "CAPA_TRANSMITIDA",
    "ITENS_TRANSMITIDOS",
    "REGISTRADA",
    "DIAGNOSTICADA_SEM_ERROS"
  ];

  const pending = [
    "DIAGNOSTICO_EM_ANDAMENTO",
    "REGISTRO_EM_ANDAMENTO"
  ];

  const error = [
    "ERRO_TRANSMISSAO_CAPA",
    "ERRO_TRANSMISSAO_ITENS",
    "ERRO_ENVIO_DIAGNOSTICO",
    "ERRO_ENVIO_REGISTRO"
  ];

  const criticalError = [
    "ERRO_GERAR_TRANSMISSAO_ITENS",
    "ERRO_GERAR_TRANSMISSAO_CAPA",
    "ERRO_PORTAL_UNICO",
    "ERRO_REGISTRO_PORTAL"
  ];

  const diagWithError = [
    "DIAGNOSTICADA_COM_ERROS"
  ];

  if (processing.includes(status)) return "#2D8CFF";      // azul
  if (done.includes(status)) return "#28C76F";            // verde
  if (pending.includes(status)) return "#FFD54F";         // amarelo
  if (diagWithError.includes(status)) return "#FFA726";   // laranja
  if (criticalError.includes(status)) return "#B80000";   // vermelho escuro
  if (error.includes(status)) return "#FF4C4C";           // vermelho

  return "#BDBDBD";
}


const statusTransmissaoDuimp = {
  TRANSMITINDO_CAPA: "Enviando Capa",
  TRANSMITINDO_ITENS: "Enviando Itens",
  ERRO_TRANSMISSAO_CAPA: "Erro capa",
  ERRO_TRANSMISSAO_ITENS: "Erro ao enviar itens",
  ERRO_GERAR_TRANSMISSAO_ITENS: "Erro gerar payload itens",
  ERRO_GERAR_TRANSMISSAO_CAPA: "Erro gerar payload capa",
  INICIANDO_TRANSMISSAO_ITENS: "Iniciando itens",
  ERRO_PORTAL_UNICO: "Erro Portal Único",
  CAPA_TRANSMITIDA: "Capa transmitida",
  ITENS_TRANSMITIDOS: "Itens transmitidos",
  REGISTRADA: "Registrada",
  DIAGNOSTICADA_SEM_ERROS: "Diagnóstico ok",
  DIAGNOSTICADA_SEM_ERROS_IMPEDITIVOS: "Diagnóstico ok",
  DIAGNOSTICADA_COM_ERROS_IMPEDITIVOS: "Diagnóstico com erro",
  DIAGNOSTICO_EM_ANDAMENTO: "Diagnóstico pendente",
  REGISTRO_EM_ANDAMENTO: "Registro pendente",
  ERRO_ENVIO_DIAGNOSTICO: "Erro envio diagnóstico",
  ERRO_ENVIO_REGISTRO: "Erro envio registro",
  ERRO_REGISTRO_PORTAL: "Erro no registro portal",
}

const hexaColorStatusICMS = {
  NAO_CONCLUIDO: '#ffff00',
  ERRO: '#ff0000',
  CONCLUIDO: '#00ff00',
};

const getHexadecimalColorByValue = (status) => getColorForStatusDuimp(status) || '#ffff00';

const getLabelByValue = (value) => statusTransmissaoDuimp[value] || defaultLabel;

const StatusDuimpUtils = {
  getHexadecimalColorByValue,
  getLabelByValue,
};

export default StatusDuimpUtils;
